
interface ServiceCard {
  id: number
  image: string
  title: string
  subtitle?: string
  description: string
}

const services: ServiceCard[] = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=300&fit=crop',
    title: 'Self Assessment',
    subtitle: '(Individuals & Sole Traders)',
    description:
      'Submit your self-assessment to HMRC with ease with step-by-step guidance, built-in validation, and optional accountant review.',
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=300&fit=crop',
    title: 'Corporation Tax (CT600) Filing',
    description:
      'File your corporation tax directly with HMRC. Supports standalone Corporation Tax or combined CT600 + company accounts submissions to Companies House.',
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=400&h=300&fit=crop',
    title: 'Company Accounts',
    subtitle: '(Companies House)',
    description:
      'Prepare and submit your annual accounts in the correct statutory format, with automatic checks for compliance.',
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop',
    title: 'Confirmation Statement',
    description:
      "Keep your company's records up to date with Companies House in just a few clicks. DIY or let us manage it for you.",
  },
]

export default function ServicesAtGlanceSection() {
  return (
    <section className='py-16 sm:py-20 lg:py-24 bg-white'>
      <div className='mx-auto px-4 sm:px-6 lg:px-8 xl:px-20'>
        {/* Header Section */}
        <div className='text-center mb-12 sm:mb-16'>
          <h2 className='text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4'>
            Our Services at a Glance
          </h2>
          <p className='text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto'>
            All your HMRC and Companies House filings in one easy platform.
          </p>
        </div>

        {/* Service Cards Grid */}
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-6 xl:gap-8'>
          {services.map(service => (
            <div
              key={service.id}
              className='bg-gray-50 rounded-xl overflow-hidden shadow-sm border border-gray-100 flex flex-col hover:shadow-md transition-shadow duration-200'
            >
              {/* Image Section */}
              <div className='relative w-full h-48 sm:h-52 lg:h-56 overflow-hidden'>
                <img
                  src={service.image}
                  alt={service.title}
                  className='w-full h-full object-cover rounded-t-xl'
                />
              </div>

              {/* Text Content Section */}
              <div className='p-5 sm:p-6 flex-grow flex flex-col'>
                <div className='mb-3'>
                  <h3 className='text-lg sm:text-xl font-bold text-gray-900 mb-1 text-left'>
                    {service.title}
                  </h3>
                  {service.subtitle && (
                    <p className='text-sm text-gray-500 font-normal text-left'>
                      {service.subtitle}
                    </p>
                  )}
                </div>
                <p className='text-sm sm:text-base text-gray-600 leading-relaxed text-left'>
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
